import styled from 'styled-components'

export const OfferDiv = styled.div`
display:flex;
min-height: 500px;
background: rgba(29, 205, 254, 0.05);
justify-content:center;

h3{
    font-size:40px;
    /* line-height:50px; */
}

h1{
  
    font-weight: bold;
    font-size: 48px;
    line-height: 64px;
    text-align: center;
    margin-bottom:100px;

}
h5{
    font-family: Gilroy;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    font-feature-settings: 'liga' off;
    color: #18191F;
}
.arrange{
    display:flex;
    flex-direction:column;
    text-align:start;
}
.knowsign{
    p{
        font-family: Gilroy;
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        line-height: 20px;
        font-feature-settings: 'liga' off;
        color: #1E90FF;

    }
}



`